module.exports = __webpack_public_path__ + "static/media/settings-android.403146bd.webp";